import { useEffect, useState } from 'react';

import {
  FONT_GOOGLE_NSW_HANDWRITING,
  FONT_GOOGLE_MONTSERRAT,
  FONT_GOOGLE_ROBOTO,
} from 'approot/shared/styles/typography.style';
import { STATIC_ASSETS } from 'webclient.constants';

// Global font cache to track loaded fonts
const fontCache = new Map<string, Promise<FontFace>>();

export const useDrawFontLoader = () => {
  const [isFontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    const loadFont = (name: string, url: string) => {
      if (!fontCache.has(name)) {
        const font = new FontFace(name, `url(${url})`, {
          style: 'normal',
          weight: 'normal',
        });
        const fontPromise = font.load().then(loadedFont => {
          document.fonts.add(loadedFont);
          return loadedFont;
        });
        fontCache.set(name, fontPromise);
      }
      return fontCache.get(name);
    };

    const fontPromises = [
      loadFont(
        FONT_GOOGLE_MONTSERRAT,
        `${STATIC_ASSETS}/fonts/montserrat.woff2`
      ),
      loadFont(
        FONT_GOOGLE_NSW_HANDWRITING,
        `${STATIC_ASSETS}/fonts/edu-nsw-act-foundation-400.woff2`
      ),
      loadFont(FONT_GOOGLE_ROBOTO, `${STATIC_ASSETS}/fonts/roboto.woff2`),
    ];

    // wait for all fonts to load
    Promise.all(fontPromises)
      .then(() => setFontsLoaded(true))
      .catch(error => {
        console.error('Failed to load fonts:', error);
      });
  }, []);

  return isFontsLoaded;
};
